import { ITypeSetItem } from "src/app/shared/util/type-set";

export interface IDirectPaymentPlanCycle {
    memberId: number;
    ncpdp: string; 
    planId: number;
    pbmDataPageId: number;
    description: string;
    cycleDate: Date;
    paymentRunId: number;
    paymentId: number;
}

export class DirectPaymentPlanCycle implements IDirectPaymentPlanCycle, ITypeSetItem<DirectPaymentPlanCycle> {
    public readonly memberId: number;
    public readonly ncpdp: string; 
    public readonly planId: number;
    public readonly pbmDataPageId: number;
    public readonly description: string;
    public readonly cycleDate: Date;
    public readonly paymentRunId: number;
    public readonly paymentId: number;

    constructor(directPaymentPlanCycle: IDirectPaymentPlanCycle) {
        this.memberId = directPaymentPlanCycle.memberId;
        this.ncpdp = directPaymentPlanCycle.ncpdp;
        this.planId = directPaymentPlanCycle.planId;
        this.pbmDataPageId = directPaymentPlanCycle.pbmDataPageId;
        this.description = directPaymentPlanCycle.description;
        this.cycleDate = directPaymentPlanCycle.cycleDate;
        this.paymentRunId = directPaymentPlanCycle.paymentRunId;
        this.paymentId = directPaymentPlanCycle.paymentId;
    }

    // ITypeSetItem<DirectPaymentPlanCycle>
    public equalTo (other: DirectPaymentPlanCycle) : boolean { 
        return this.planId === other.planId && this.memberId === other.memberId;
    }

    public static sort (a: IDirectPaymentPlanCycle, b: IDirectPaymentPlanCycle) {
        if (a.description === b.description) {
            return a.paymentRunId - b.paymentRunId;
        }
        return a.description.localeCompare(b.description);
    }
} 